/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Ticketsissuepricetoolow4Inputs */

const en_ticketsissuepricetoolow4 = /** @type {(inputs: Ticketsissuepricetoolow4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paid tickets cost at least ${i?.min}.`)
};

const de_ticketsissuepricetoolow4 = /** @type {(inputs: Ticketsissuepricetoolow4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bezahlte Tickets kosten mindestens ${i?.min}.`)
};

/**
* | output |
* | --- |
* | "Paid tickets cost at least {min}." |
*
* @param {Ticketsissuepricetoolow4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissuepricetoolow4 = /** @type {((inputs: Ticketsissuepricetoolow4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissuepricetoolow4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissuepricetoolow4(inputs)
	return de_ticketsissuepricetoolow4(inputs)
});
export { ticketsissuepricetoolow4 as "ticketsIssuePriceTooLow" }